import * as React from 'react';

import { UitkUnformattedHtml } from 'uitk-react-unformatted-html';

export interface AmenityBodyProps {
  text: string;
  index: number;
  category: string;
}

export const AmenityBody: React.FunctionComponent<AmenityBodyProps> = ({ text, index, category }) => (
  <UitkUnformattedHtml>
    <div
      className={`policies__body all-t-margin-two info-${category}__section__body`}
      dangerouslySetInnerHTML={{ __html: text }}
      key={`${category}-${index}`}
    />
  </UitkUnformattedHtml>
);
